import { profileStartup, startStartupProfile } from './diagnostics/startup-profile';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { App } from './app';
import { SessionProvider } from './auth/session';
import { ApiError } from './api/client';
import { ГраницаОшибки } from './ui/granica-oshibki';
import './styles.css';
import { startStartupMeasure } from './diagnostics/startup-measure';

/**
 * Точка входа.
 *
 * НАСТРОЙКИ ЗАПРОСОВ ЗАДАНЫ ЗДЕСЬ ОДИН РАЗ и не повторяются по экранам:
 * иначе один экран повторяет неудачные запросы, соседний нет, и поведение
 * кабинета зависит от того, кто какой экран писал.
 */
const client = new QueryClient({
  defaultOptions: {
    queries: {
      // Повтор только для сетевых сбоев. Отказ доступа или «не найдено»
      // повторять бессмысленно: ответ не изменится, а человек три раза
      // подряд ждёт одного и того же отказа.
      retry: (count, error) => !(error instanceof ApiError) && count < 2,
      staleTime: 30_000,
      refetchOnWindowFocus: true,
    },
  },
});

startStartupMeasure(client);
startStartupProfile();

const root = document.getElementById('rk-root');
if (!root) throw new Error('нет узла #rk-root — проверьте index.html');

createRoot(root).render(profileStartup('application',
  <StrictMode>
    <QueryClientProvider client={client}>
      <BrowserRouter>
        <SessionProvider>
          {/* ВНЕШНЯЯ ГРАНИЦА — довод целиком в `granica-oshibki.tsx`.
              Коротко: 30.08 ошибка в одном окне погасила весь кабинет
              до серого прямоугольника. */}
          <ГраницаОшибки место="кабинет">
            <App />
          </ГраницаОшибки>
        </SessionProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
));
